import module from 'contabilidad/clientescuentascontables/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('contabilidad.clientesCuentasContables.cliente', {
    url: '/{idCliente}',
    abstract: true,
    data: {
      titleProxy: 'contabilidad.clientesCuentasContables.cliente.cuentas',
    },
    resolve: {
      idCliente: ($stateParams) => $stateParams.idCliente,
      clientes: ($catalogos, idCliente) => $catalogos.get('clientes')
        .then((clientes) => clientes.find((item) => item.ID_Cliente === idCliente)),
    },
    template: '<contabilidad-clientescuentascontables-detalle clientes="clientes"/>',
    controller: ($scope, clientes) => {
      $scope.clientes = clientes
    },
  })
})



// WEBPACK FOOTER //
// ./src/contabilidad/clientescuentascontables/routes/contabilidad/clientesCuentasContables/lista/detalle.js